import React from 'react';
import { Dialog, DialogContent, Button, TextField, Switch, Fab, Divider, ListItem, ListItemText, List, Radio, CircularProgress, ExpansionPanel, ExpansionPanelDetails, DialogActions } from '@material-ui/core'
import PropTypes from 'prop-types'
import Utils from '../../providers/Utils';
import ListaRaspunsuri from './ListaRaspunsuri';
import WsC from './providers/WsC'
import RaspunsDialog from './RaspunsDialog';
import DialogSubIntrebare from './DialogSubIntrebare';
import ListGrupaje from './ListGrupaje';
import AlertChestionar from './AlertChestionar'
import { ReactComponent as CogSolid } from './Icoane Font Awesome/cog-solid.svg';
import { ReactComponent as SaveRegular } from './Icoane Font Awesome/save-regular.svg';


export default class AddIntrebare extends React.Component {
    constructor(props) {
        super(props);
        this.subIntrebare = React.createRef()
        this.listSubIntrebari = React.createRef()
        this.grupajeList = React.createRef()
        this.state = {
            optiuniRaspuns: new Utils().raspunsuriPredefinite,
            sliderRaspunsuri: new Utils().generateRaspunsuri(),
            raspunsSelectat: 8,
            listRaspunsuri: this.props.raspunsuri,
            isOpenRaspuns: false,
            isOpenRaspunsUpdate: false,
            strNume: '',
            strPuncte: '0',
            slideValue: '50',
            strRaspunsNume: '',
            objRaspunsInfo: {},
            showRaspunsuri: false,
            selectedValue: '',
            strTip: 'radio',
            listTipuriIntrebari: new Utils().tipIntrebari,
            fullScreen: false,
            objIntrebareChild: { tip: 'radio' },
            isOpenSubintrebare: false,
            intrebariChild: [],
            loading: false,
            img: false,
            openAlert: false,
            alertText: '',
            panel1: false,
            panel2: false
        }
    }

    resetValues = () => {
        this.setState({
            raspunsSelectat: 8,
            listRaspunsuri: this.props.raspunsuri,
            isOpenRaspuns: false,
            isOpenRaspunsUpdate: false,
            strNume: '',
            strPuncte: '0',
            slideValue: '50',
            strRaspunsNume: '',
            objRaspunsInfo: {},
            showRaspunsuri: false,
            selectedValue: '',
            listTipuriIntrebari: new Utils().tipIntrebari,
            isOpenSubintrebare: false,
            intrebariChild: [],
            loading: false,
            img: false
        })
    }

    componentDidMount() {
        this.getWindowDimentions()
    }

    getWindowDimentions = () => {
        let windowWidth = window.innerWidth

        // console.log('windowWidth :', windowWidth);
        this.setState({
            fullScreen: windowWidth <= 800 ? true : false
        }, () => {
            // console.log('(object) :', this.state.fullScreen);
        })

    }

    filterTipuri = () => {

        //console.log('listRaspunsuri :', this.state.listRaspunsuri);
        if (this.state.listRaspunsuri.length > 0) {

            if (this.state.listRaspunsuri[0].tip === 'text') {
                this.setState({ listTipuriIntrebari: new Utils().tipIntrebari })
            } else {
                let tipuri = [...this.state.listTipuriIntrebari]

                let filterTipuri = tipuri.filter(t => t.id !== 'text')

                this.setState({ listTipuriIntrebari: filterTipuri })
            }


        } else {
            this.setState({ listTipuriIntrebari: new Utils().tipIntrebari })
        }
    }


    getTipIntrebare = () => {
        // console.warn('get tip intrebare ----- ', this.props.objIntrebareInfo)
        this.setState({
            strTip: this.props.objIntrebareInfo.tip,
            img: this.props.objIntrebareInfo.tip.indexOf('img') !== -1 ? true : false
        })
    }
    insertRaspuns = async () => {

        let ws = new WsC();


        let raspuns = { label: '', id_intrebare: this.props.objIntrebareInfo.id, puncte: 0 }
        //console.log('this.props.intrebareInfo :', this.props.objIntrebareInfo);

        console.log('raspuns :>> ', raspuns);

        let insertRaspuns = await ws.insert('chestionare_intrebari_optiuni_raspuns', raspuns)


        if (insertRaspuns.Succes) {

            let listCloneRaspuns = [...this.state.listRaspunsuri]
            raspuns.id = insertRaspuns.Content[0].id
            raspuns.inactiv = 0
            raspuns.img_src = null

            listCloneRaspuns.push(raspuns)



            this.setState({
                listRaspunsuri: listCloneRaspuns,
                strRaspunsNume: '',
                strPuncte: '',
                isOpenRaspuns: false,

            }, () => {
                this.filterTipuri()
                this.props.getRaspunsuri()
            })

        }


    }

    getRaspunsuri = async () => {

        let ws = new WsC();

        if (this.props.objIntrebareInfo.tip !== 'grupaj') {
            // console.log('this.props.objIntrebareInfo.id :', this.props.objIntrebareInfo.id);
            let getRaspunsuri = await ws.customSelect('select * from chestionare_intrebari_optiuni_raspuns where isnull(inactiv,0) != 1 and id_intrebare = @p1 order by id asc', {
                p1: this.props.objIntrebareInfo.id
            })


            // console.log('intrebare simpla :');



            console.warn('getRaspunsuri :', getRaspunsuri);
            if (getRaspunsuri.Succes) {
                this.setState({
                    listRaspunsuri: getRaspunsuri.Content,

                }, () => {
                    this.filterTipuri()
                    this.props.getRaspunsuri()
                    this.props.getChestionar()
                })

            }
        } else if (this.props.objIntrebareInfo.tip === 'grupaj') {

            //  console.log('this.props.objIntrebareInfo :', this.props.objIntrebareInfo);
            let getIntrebariChildren = ws.customSelect('select * from chestionare_intrebari where id_parent = @p2 and isnull(inactiv,0) != 1 order by isnull(ordinea,0) asc, id', {
                p2: this.props.objIntrebareInfo.id
            })

            let raspunsuriChild = ws.customSelect('select * from chestionare_intrebari_optiuni_raspuns where id_intrebare in (select id from chestionare_intrebari where id_parent = @p2 and isnull(inactiv,0) != 1) and isnull(inactiv,0) != 1 order by id asc', {
                p1: this.props.objIntrebareInfo.id_chestionar,
                p2: this.props.objIntrebareInfo.id
            })

            let [i, r] = await Promise.all([getIntrebariChildren, raspunsuriChild])

            if (i.Succes && r.Succes) {
                //   console.log('intrebari copii :', i);
                //  console.log('raspunsuri intrebari copii :', r);

                let raspunsuri = []

                for (let v = 0, n = i.Content.length; v < n; v++) {
                    let raspunsuriFilter = r.Content.filter(rasp => rasp.id_intrebare === i.Content[v].id).map((m, idx) => {



                        return m.label
                    }).join(', ')



                    raspunsuri.push({
                        idx: v + 1,
                        id_intrebare: i.Content[v].id,
                        id_grupaj: i.Content[v].id_grupaj,
                        label: raspunsuriFilter,
                        id_parent: i.Content[v].id_parent,
                        img_src: null,
                        label_rapoarte: null,
                        motivatie_raspun: null
                    })

                }

                // console.warn('this.props.objIntrebareInfo :', this.props.objIntrebareInfo);

                this.setState({
                    listRaspunsuri: raspunsuri,

                }, () => {
                    this.grupajeList.current.getSubIntrebari()
                    this.filterTipuri()
                    // this.props.getRaspunsuri()

                })
                // console.log('raspunsuri :', raspunsuri);
            }
        }



    }

    goToRaspuns = (r) => {

        if (this.props.objIntrebareInfo.tip === 'grupaj') {

            let intrebareToAdd = {
                idx: r.idx,
                id: r.id_intrebare,
                intrebare: this.props.nume,
                id_parent: this.props.objIntrebareInfo.id,
                id_grupaj: r.id_grupaj,
                id_categorie: 1,
                tip: 'radio',
            }

            this.setState({
                isOpenSubintrebare: true,
                objIntrebareChild: intrebareToAdd,
            }, () => {
                this.subIntrebare.current.getRaspunsuri()
            })


        }
        else if (this.props.objIntrebareInfo.tip === 'subintrebare') {

            // console.log('r :', r);

            this.setState({
                isOpenSubintrebare: true,
                objIntrebareChild: r
            }, () => {
                this.subIntrebare.current.getRaspunsuri()
            })
        }
        else {

            // console.log('r :', r);

            this.setState({
                strRaspunsNume: r.label,
                strPuncte: r.puncte,
                objRaspunsInfo: r,
                isOpenRaspunsUpdate: true,

            })
        }


    }

    updateRaspuns = async (r) => {


        let ws = new WsC();

        //console.log('objRaspunsInfo------ :', this.state.objRaspunsInfo)

        console.log('r :>> ', r);


        let updateR = await ws.update('chestionare_intrebari_optiuni_raspuns', { label: r.label, puncte: Number(r.puncte) }, { id: r.id })


        //  console.log('updateR :', updateR);

        if (updateR.Succes) {
            let listRaspunsuri = [...this.state.listRaspunsuri]

            let idx = listRaspunsuri.findIndex(l => l.id === r.id)

            if (idx !== -1) {

                listRaspunsuri[idx].label = r.label
            }


            this.setState({
                listRaspunsuri: listRaspunsuri,
                strRaspunsNume: '',
                isOpenRaspunsUpdate: false
            }, () => {

                this.getRaspunsuri()

            })
        }





    }




    deleteRaspuns = async (r) => {

        let ws = new WsC()
        if (this.props.objIntrebareInfo.tip === 'grupaj') {

            //console.log('raspuns to delete :', r);
            let deleteRaspuns = await ws.update('chestionare_intrebari', { inactiv: 1 }, { id: r.id })

            if (deleteRaspuns.Succes) {


                this.getRaspunsuri()
                this.filterTipuri()
            }



        } else if (this.props.objIntrebareInfo.tip === 'subintrebare') {

            console.warn('subintrebare :', r);
            let deleteRaspuns = await ws.update('chestionare_intrebari', { inactiv: 1 }, { id: r.id })

            if (deleteRaspuns.Succes) {



                // let listCloneRaspunsuri = [...this.state.listRaspunsuri]
                // console.log('listCloneRaspunsuri :', listCloneRaspunsuri);
                this.listSubIntrebari.current.getSubIntrebari()
            }
        }


        else {
            let deleteRaspuns = await ws.update('chestionare_intrebari_optiuni_raspuns', { inactiv: 1 }, { id: r.id })

            if (deleteRaspuns.Succes) {
                let listCloneRaspunsuri = [...this.state.listRaspunsuri]

                let idx = listCloneRaspunsuri.findIndex(cr => cr.id === r.id)

                listCloneRaspunsuri.splice(idx, 1)

                this.setState({ listRaspunsuri: listCloneRaspunsuri }, () => {
                    this.props.getRaspunsuri()
                    this.filterTipuri()
                })
            }

        }






    }

    insertIntrebareCopil = async () => {

        let ws = new WsC();

        // let intrebare = this.props.objIntrebareInfo
        let u = new Utils()

        let intrebareToAdd = {
            id_chestionar: this.props.objIntrebareInfo.id_chestionar,
            intrebare: '',
            id_parent: this.props.objIntrebareInfo.id,
            id_grupaj: u.generateId(),
            id_categorie: 1,
            tip: 'radio',
        }
        //console.log('intrebare Parent:', intrebare);
        //console.log('intrebareToAdd :', intrebareToAdd);

        let insert = await ws.insert('chestionare_intrebari', intrebareToAdd)

        //console.log('insert :', insert);

        if (insert.Succes) {

            intrebareToAdd.id = insert.Content[0].id

            let raspuns = { label: this.state.strRaspunsNume, id_intrebare: insert.Content[0].id, puncte: this.state.strPuncte }

            let countRasp = 0

            for (let i = 0; i < 2; i++) {
                let insertRaspuns = await ws.insert('chestionare_intrebari_optiuni_raspuns', raspuns)

                if (insertRaspuns.Succes) {
                    countRasp += 1
                }
            }

            if (countRasp === 2) {
                //console.log('this.props.intrebareInfo :', this.props.objIntrebareInfo);



                let intrebariChild = [...this.state.intrebariChild]

                intrebariChild.push(intrebareToAdd)

                this.setState({
                    objIntrebareChild: intrebareToAdd,
                    intrebariChild: intrebariChild
                }, () => {


                })
            }



        }


    }

    insertSubintrebare = async () => {
        let ws = new WsC();

        // let intrebare = this.props.objIntrebareInfo
        // let u = new Utils()

        let intrebareToAdd = {

            id_chestionar: this.props.objIntrebareInfo.id_chestionar,
            intrebare: '',
            id_parent: this.props.objIntrebareInfo.id,
            id_grupaj: '',
            id_categorie: 1,
            tip: 'radio',
        }
        //console.log('intrebare Parent:', intrebare);
        //console.log('intrebareToAdd :', intrebareToAdd);

        let insert = await ws.insert('chestionare_intrebari', intrebareToAdd)

        //console.warn('insert :', insert);

        if (insert.Succes) {


            intrebareToAdd.id = insert.Content[0].id

            let intrebariChild = [...this.state.intrebariChild]

            intrebariChild.push(intrebareToAdd)

            this.setState({
                isOpenSubintrebare: true,
                objIntrebareChild: intrebareToAdd,
                intrebariChild: intrebariChild
            }, () => {

            })
        }

    }


    salveaza = async (t = null) => {

        //console.log('a intrnt in salveaza :');


        let ws = new WsC();

        //console.log('t :', t);

        let objToUpdate = {
            intrebare: this.props.nume,
            tip: t ? t : this.props.objIntrebareInfo.tip,
            motivatie_label: this.props.objIntrebareInfo.motivatie_label || ''
        }

        if (t === 'grupaj') {
            let filterRaspunsuri = [...this.state.listRaspunsuri]


            let update = await ws.update('chestionare_intrebari_optiuni_raspuns', { inactiv: 1 }, { id_intrebare: this.props.objIntrebareInfo.id })


            if (update.Succes) {
                // console.log('update intrebare :', update);

                // console.warn('filterRaspunsuri :', filterRaspunsuri);
                filterRaspunsuri = filterRaspunsuri.filter(r => Number(r.id_parent) === Number(this.props.objIntrebareInfo.id))

                //console.log('filterRaspunsuri :', filterRaspunsuri);

                if (filterRaspunsuri.length === 0) {
                    for (let i = 0; i < 3; i++) {
                        await this.insertIntrebareCopil()

                    }
                } else {

                }

            }

        }else if(t === 'text'){

            let update = await ws.update('chestionare_intrebari_optiuni_raspuns', { inactiv: 1 }, { id_intrebare: this.props.objIntrebareInfo.id })

            if(update.Succes){
                let insertRaspuns = await ws.insert('chestionare_intrebari_optiuni_raspuns', { id_intrebare: this.props.objIntrebareInfo.id, label: '', tip: t })
            }
        }

        this.setState({ loading: false }, () => {
            this.props.updateIntrebare(objToUpdate, { id: this.props.objIntrebareInfo.id })
            // this.getRaspunsuri()
        })



    }

    tipChange = (value) => {

        let intrebareChild = { ...this.state.objIntrebareChild }

        intrebareChild.tip = value



        this.setState({
            strTip: value,
            panel1: false,
            objIntrebareChild: intrebareChild,
            loading: true
        }, () => {
            this.salveaza(value)
            // console.log(' str tip:>> ', this.state.strTip);
        })
    }

    openTrue = () => {

        //console.log('raspunsuri from parent ---------- :', this.props.rapspunsuri);



        this.setState({ listRaspunsuri: this.props.raspunsuri })
    }


    showButton = () => {

        if ((this.props.nume.length > 3) && (this.props.objIntrebareInfo.id !== null)) {
            return false
        } else {
            return true
        }
    }

    raspunsuriClick = () => {

        //console.log('this.state.optiuniraspunssssssss :', this.state.optiuniRaspuns);
        this.setState({ showRaspunsuri: this.state.showRaspunsuri === false ? true : false }, () => {
            //    console.log('showRaspunsuri :', this.state.showRaspunsuri);
        })
    }

    getRaspunsuriJson = async () => {
        //console.log('this.state.selectedValue :', this.state.selectedValue);

        let ws = new WsC();
        let cloneOptiuniRaspuns = [...this.state.optiuniRaspuns]

        let raspunsuri = cloneOptiuniRaspuns[this.state.selectedValue].optiuniRaspuns

        let counter = raspunsuri.length


        let cloneListRaspunsuri = [...this.state.listRaspunsuri]

        console.log('raspunsuri :>> ', cloneOptiuniRaspuns[this.state.selectedValue]);

        console.log('id :>> ', this.props.objIntrebareInfo.id);

        let update = await ws.update('chestionare_intrebari_optiuni_raspuns', { inactiv: 1 }, { id_intrebare: this.props.objIntrebareInfo.id })



        // let [update, updateIntrebare] = await Promise.all([_update, _updateIntrebare])


        // console.log('i[dateIntrebare] :>> ', updateIntrebare);

        if (update.Succes) {
            for (let i = 0; i < counter; i++) {
                cloneListRaspunsuri.push({
                    label: raspunsuri[i].Label,
                    puncte: raspunsuri[i].puncte,
                    id_intrebare: this.props.objIntrebareInfo.id
                })

            }

            //console.log('raspunsuri :', raspunsuri);

            //console.log('this.props.objIntrebareInfo.id :', this.props.objIntrebareInfo.id);


            await this.salveaza(this.state.strTip)





            let sendMultiRapsuns = await ws.postDataLite('Chestionare/InsereazaMultiRaspunsuri', raspunsuri, {
                idIntrebare: this.props.objIntrebareInfo.id,
                tipIntrebare: this.state.strTip
            })

            //console.log('object :', sendMultiRapsuns);

            if (sendMultiRapsuns.Succes) {


                let tip = ''

                if (cloneOptiuniRaspuns[this.state.selectedValue].tip.indexOf('img') !== -1) {
                    if (this.state.strTip === 'checkbox') {
                        tip = 'img_multiple'
                    } else if (this.state.strTip === 'radio') {
                        tip = 'img_single'
                    } else if (this.state.strTip === 'grupaj') {
                        tip = 'img_single'
                    } else {
                        tip = this.state.strTip
                    }

                } else {
                    if (this.state.strTip === 'img_multiple') {
                        tip = 'checkbox'
                    } else if (this.state.strTip === 'img_single') {
                        tip = 'radio'
                    } else if (this.state.tip === 'grupaj') {
                        tip = 'radio'
                    } else {
                        tip = this.state.strTip
                    }
                }

                this.props.updateIntrebare({ tip: tip }, { id: this.props.objIntrebareInfo.id })


                this.setState({
                    listRaspunsuri: cloneListRaspunsuri,
                    showRaspunsuri: false,
                    selectedValue: '',
                    strTip: tip,
                    img: cloneOptiuniRaspuns[this.state.selectedValue].tip.indexOf('img') !== -1 ? true : false

                }, () => {

                    this.getRaspunsuri()
                })


            }

        }


    }


    handleChangePanel = (name) => {
        this.setState({ [name]: this.state[name] ? false : true })
    }



    filterRaspunsuri = () => {
        let cloneRaspunsuri = [...this.state.optiuniRaspuns]

        //console.log('cloneRaspunsuri :', cloneRaspunsuri);

        return cloneRaspunsuri.map((r, idx) => {

            return (
                <ListItem style={{ padding: '5px 0 5px 0' }} key={idx}>
                    <Radio
                        style={{ padding: 0 }}
                        value={idx}
                        checked={this.state.selectedValue === idx}
                        onChange={() => { this.setState({ selectedValue: idx, panel2: false }, async () => { this.getRaspunsuriJson() }) }}
                    />
                    <ListItemText
                        style={{ padding: 0, paddingLeft: 10 }}
                        primary={<span onClick={() => { this.setState({ selectedValue: idx, panel2: false }, async () => { this.getRaspunsuriJson() }) }}
                            className='chestionare-list-subtext'
                            style={{ margin: 0, fontSize: 14, cursor: 'pointer' }}
                        >
                            {idx + 1}.
                        {r.tip === 'img_single' &&
                                <span>
                                    {r.optiuniRaspuns.map((oR, idx) => {
                                        return (<span style={{ marginLeft: 10 }} key={idx}>
                                            <i className='material-icons'>image</i>,</span>)
                                    })} Raspunsuri cu imagini
                            </span>
                            }

                            {r.tip === 'img_multiple' &&
                                <span>
                                    {r.optiuniRaspuns.map((oR, idx) => {
                                        return (<span style={{ marginLeft: 10 }} key={idx}>
                                            <i className='material-icons'>image</i>,</span>)
                                    })} Imagini cu mai multe variante de raspuns
                            </span>
                            }



                            {r.optiuniRaspuns.map((oR, idx) => {
                                if (!r.tip.includes('img')) {


                                    if (r.edit === 1) {
                                        return (

                                            <span style={{ marginLeft: 10, display: 'inline-block' }} key={idx}>{oR.Label}
                                                <i
                                                    style={{
                                                        fontSize: 14,
                                                        color: 'red',
                                                        verticalAlign: 'sub',
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={() => { this.deleteOptiune(r, oR) }} className='material-icons'>delete</i>,</span>


                                        )

                                    } else {
                                        return (
                                            <span style={{ marginLeft: 10, display: 'inline-block' }} key={idx}>{oR.Label},</span>

                                        )
                                    }
                                }





                            })}
                        </span>}
                    // secondary={<span style={{ margin: 'auto', display: r.edit !== 1 ? 'none' : 'block' }}>

                    //     <input className='slider'
                    //         type='range'
                    //         min='1'
                    //         max='100'
                    //         step={1}
                    //         name='pm-slider'
                    //         onMouseUp={(ev) => { this.addValueToAO(ev) }}
                    //         onChange={(ev) => { this.setState({ slideValue: ev.target.value }) }} value={this.state.slideValue} />
                    //     {this.state.slideValue}</span>}
                    />

                </ListItem>
            )

        })


    }

    addValueToAO = (ev) => {
        let optiuniRaspuns = [...this.state.optiuniRaspuns]

        let idx = optiuniRaspuns.findIndex(o => o.edit === 1)

        optiuniRaspuns[idx].optiuniRaspuns.push({ Label: ev.target.value, Puncte: Number(ev.target.value) })

        this.setState({ optiuniRaspuns: optiuniRaspuns })
    }

    deleteOptiune = (r, oR) => {

        // console.log('r :', r);
        // console.log('oR :', oR);

        let optiuniRaspuns = [...this.state.optiuniRaspuns]

        let idxR = optiuniRaspuns.findIndex(i => i.id === r.id)

        let raspunsuri = optiuniRaspuns[idxR].optiuniRaspuns

        // console.log('raspunsuri :', raspunsuri);

        let idxoR = raspunsuri.findIndex(i => i.Puncte === oR.Puncte)

        // console.log('idxoR :', idxoR);

        raspunsuri.splice(idxoR, 1)

        this.setState({ optiuniRaspuns: optiuniRaspuns })



    }

    insertOrUpdate = () => {

        //console.log('object :');

        // console.log('this.props.objIntrebareInfo.length :', this.props.objIntrebareInfo.id !== null);
        this.props.objIntrebareInfo.id !== null ? this.salveaza() : this.props.insert(this.state.selectedValue)
    }

    addRaspuns = () => {



        if (this.props.objIntrebareInfo.tip.includes('img')) {
            this.insertRaspuns()
        } else if (this.state.strTip === 'grupaj') {
            this.insertIntrebareCopil()
        } else if (this.state.strTip === 'subintrebare') {
            // console.log('SUBINTREBARE :>> ', this.state.strTip);
            this.insertSubintrebare()
        }

        else {
            this.setState({ isOpenRaspuns: true })
        }
    }

    changeSubintrebareTitle = (ev) => {
        let subIntrebare = { ...this.state.objIntrebareChild }

        subIntrebare.intrebare = ev.target.value

        this.setState({ objIntrebareChild: subIntrebare })
    }


    updateSubintrebare = async () => {

        let objSubintrebare = {
            intrebare: this.state.objIntrebareChild.intrebare,
            motivatie_label: this.state.objIntrebareChild.motivatie_label || ''
        }

        let ws = new WsC()

        let subUpdate = await ws.update('chestionare_intrebari', objSubintrebare, { id: this.state.objIntrebareChild.id })

        if (subUpdate.Succes) {
            this.listSubIntrebari.current.getSubIntrebari()
        }

    }


    changeMotivatie = (ev) => {
        let subIntrebare = { ...this.state.objIntrebareChild }

        subIntrebare.motivatie_label = ev.target.value

        this.setState({ objIntrebareChild: subIntrebare })
    }

    adaugaRaspunsGrupaj = async (r) => {
        //console.log('intrebareGrupaj :', r);

        let ws = new WsC();


        let raspuns = { label: '', id_intrebare: r.id, puncte: this.state.strPuncte }
        // console.log('this.props.intrebareInfo :', this.props.objIntrebareInfo);

        //console.log('raspuns :', raspuns);

        let insertRaspuns = await ws.insert('chestionare_intrebari_optiuni_raspuns', raspuns)


        if (insertRaspuns.Succes) {

            let listCloneRaspuns = [...this.state.listRaspunsuri]
            raspuns.id = insertRaspuns.Content[0].id
            raspuns.inactiv = 0
            raspuns.img_src = null

            listCloneRaspuns.push(raspuns)



            this.setState({
                listRaspunsuri: listCloneRaspuns,
                strRaspunsNume: '',
                strPuncte: '',
                isOpenRaspuns: false,

            }, () => {
                this.grupajeList.current.getSubIntrebari()
                this.filterTipuri()
                this.props.getRaspunsuri()
            })

        }

    }

    insertIntrebareRow = async () => {
        let ws = new WsC();

        // let intrebare = this.props.objIntrebareInfo
        let u = new Utils()

        let intrebareToAdd = {
            id_chestionar: this.props.objIntrebareInfo.id_chestionar,
            intrebare: '',
            id_parent: this.props.objIntrebareInfo.id,
            id_grupaj: u.generateId(),
            id_categorie: 1,
            tip: 'radio',
        }
        // console.log('intrebare Parent:', intrebare);
        //console.log('intrebareToAdd :', intrebareToAdd);

        let insert = await ws.insert('chestionare_intrebari', intrebareToAdd)

        // console.log('insert :', insert);

        if (insert.Succes) {

            intrebareToAdd.id = insert.Content[0].id

            let raspuns = { label: this.state.strRaspunsNume, id_intrebare: insert.Content[0].id, puncte: this.state.strPuncte }

            let countRasp = 0

            for (let i = 0; i < 2; i++) {
                let insertRaspuns = await ws.insert('chestionare_intrebari_optiuni_raspuns', raspuns)

                if (insertRaspuns.Succes) {
                    countRasp += 1
                }
            }

            if (countRasp === 2) {
                // console.log('this.props.intrebareInfo :', this.props.objIntrebareInfo);



                let intrebariChild = [...this.state.intrebariChild]

                intrebariChild.push(intrebareToAdd)

                this.setState({
                    objIntrebareChild: intrebareToAdd,
                    intrebariChild: intrebariChild
                }, () => {
                    this.props.getChestionar()
                    this.grupajeList.current.getSubIntrebari()
                })
            }



        }
    }

    closeDialog = () => {


        this.setState({
            strTip: 'radio',
            objIntrebareChild: { tip: 'radio' },
        }, () => {
            this.props.dialogClose()
        })



    }

    finalizeaza = () => {

        // console.log('this.state.listRaspunsuri :', this.state.listRaspunsuri);

        // console.log('this.props.chestionarInfo :', this.props.chestionarInfo);



        console.log('this.state.strTip :>> ', this.state.strTip);

        let raspunsuriFilter = this.state.listRaspunsuri.filter(r => Number(r.puncte) > 0)

        // console.log('raspunsuriFilter :', raspunsuriFilter);

        if (raspunsuriFilter.length > 0) {
            this.setState({
                strTip: 'radio',
                objIntrebareChild: { tip: 'radio' },
            }, () => {
                this.props.finalizeaza()
            })
        } else if (this.state.strTip === 'text') {
            this.setState({
                strTip: 'radio',
                objIntrebareChild: { tip: 'radio' },
            }, () => {
                this.props.finalizeaza()
            })
        } else {
            this.props.finalizeaza()
        }





    }


    handleChecked = (ev) => {

        let checked = ev.target.checked


        let tip = ''


        if (checked) {
            if (this.state.strTip === 'radio') {
                tip = 'img_single'
            } else {
                tip = 'img_multiple'
            }
        } else {
            if (this.state.strTip === 'img_single') {
                tip = 'radio'
            } else {
                tip = 'checkbox'
            }
        }




        this.setState({
            img: checked,
            strTip: tip
        }, () => {
            this.props.updateIntrebare({ tip: tip }, { id: this.props.objIntrebareInfo.id })
        })
    }


    tipuriIntrebariLabel = () => {
        if (this.state.strTip === 'radio') {
            return 'O singura varianta de raspuns'
        } else if (this.state.strTip === 'checkbox') {
            return 'Mai multe variante de raspuns'
        } else if (this.state.strTip === 'grupaj') {
            return 'Raspunsuri grupate'
        } else if (this.state.strTip === 'subintrebare') {
            return 'Intrebare cu subintrebari'
        } else if (this.state.strTip === 'img_single') {
            return 'O singura varianta de raspuns'
        } else if (this.state.strTip === 'img_multiple') {
            return 'Mai multe variante de raspuns'
        } else {
            return 'Text Liber'
        }
    }


    changeRaspuns = (ev, r) => {

        let val = ev.target.value
        let name = ev.target.name

        console.log('r :>> ', r);
        console.log('val :>> ', val);

        let listRaspunsuri = [...this.state.listRaspunsuri]


        let idx = listRaspunsuri.findIndex(l => l.id === r.id)

        if (idx !== -1) {

            listRaspunsuri[idx][name] = val

            this.setState({ listRaspunsuri: listRaspunsuri })
        }

    }


    render() {
        return (
            <div>

                <AlertChestionar
                    open={this.state.openAlert}
                    dialogClose={() => { this.setState({ openAlert: false }) }}
                    title={this.state.alertText}
                    yesFunction={() => { this.setState({ openAlert: false }) }}
                    noButtonDisplay={1}
                />

                <Dialog
                    className="insertDialog"
                    disableEscapeKeyDown
                    fullScreen={this.state.fullScreen}
                    fullWidth={true}
                    maxWidth={'xs'}
                    open={this.props.open}
                    onClose={this.closeDialog}>
                    {/* <DialogActions >
                        <Fab onClick={this.closeDialog} className="chestionare-anuleaza-button">
                            <i className='material-icons textSecondary iconFontSize'>close</i>
                        </Fab>
                    </DialogActions> */}
                    <DialogContent style={{
                        backgroundColor: 'white',
                        borderRadius: 20,
                        position: 'relative',
                        width: '95%',
                        margin: 'auto',

                        padding: '0 10px 0 10px',
                        height: 'inherit',
                        overflowX: 'hidden',
                        overflowY: 'scroll',
                        marginBottom: 40
                    }}>


                        <div className='stickyTitle' >


                            <h4 className='cardTitle' style={{ margin: '40px 0 40px 0', display: 'flex', justifyContent: 'space-between' }}><span style={{ fontWeight: 600 }}>{this.props.chestionarInfo.titlu}</span>
                                {/* <i className='material-icons iconFontSize textSecondary'>save</i> */}

                            </h4>

                            <Divider className='chestionare-divider' />
                        </div>

                        <div style={{ textAlign: 'left' }}>

                            <div style={{ position: 'relative', marginTop: 20, marginBottom: 10 }}>
                                <textarea
                                    id='titluIntrebare'
                                    style={{ width: '100%' }}
                                    className='add-project-input'
                                    type="text"
                                    margin="normal"
                                    name='titlu'
                                    value={this.props.nume || ''}
                                    placeholder='Enuntul intrebarii'
                                    onChange={this.props.numeChange}
                                    onBlur={this.insertOrUpdate}
                                ></textarea>




                                <label className='inputLabelPM' htmlFor='titluIntrebare'>Intrebarea</label>

                            </div>


                            {this.props.objIntrebareInfo.id === null &&
                                <div style={{ textAlign: 'right', margin: '0 0 20px 0' }}>
                                    <Button style={{ width: 'fit-content', marginBottom: 20, marginLeft: 20 }} variant="contained" onClick={() => { console.log('update :>> '); }} className='chestionare-adauga-raspuns-button'>
                                        Mai Departe
                                 </Button>
                                </div>
                            }


                            <Divider className='pm-divider' />


                        </div>



                        {/* {this.state.strTip.indexOf('motivatie') !== -1 &&
                            <TextField label='Scrie aici text motivatie'
                                onBlur={this.insertOrUpdate}
                                multiline
                                value={this.props.objIntrebareInfo.motivatie_label || ''}
                                onChange={this.props.motivatieChange}
                                className='inputFocus' style={{ width: '90%' }} />
                        } */}


                        {this.props.objIntrebareInfo.id !== null &&
                            this.props.objIntrebareInfo.tip.indexOf('img') === -1 &&
                            <div>
                                <h4 onClick={() => { this.handleChangePanel('panel1') }} className='cardTitle' style={{ margin: 20, display: 'flex', justifyContent: 'space-between', cursor: 'pointer' }}><span style={{ fontWeight: 700, textTransform: 'uppercase', fontSize: 14 }}>{this.tipuriIntrebariLabel()}</span>
                                    <span>

                                        <CogSolid className='textSecondary iconSvg' style={{ marginRight: 0, width: 18, height: 18 }} />
                                    </span>

                                    {/* <i  className='material-icons iconFontSize textSecondary'>settings</i> */}
                                </h4>

                                <ExpansionPanel className='chestionare-expantion' style={{ margin: 'auto', maxWidth: 350 }} expanded={this.state.panel1} onChange={() => { this.handleChangePanel('panel1') }}>


                                    {/* {this.state.isShowPreview !== true && */}

                                    <ExpansionPanelDetails style={{ display: 'block' }}>

                                        <ul style={{ textAlign: 'left', listStyleType: 'none', marginTop: 0, paddingTop: 0, paddingLeft: 0, borderLeft: '1px solid #f0f0f0' }}>
                                            {this.props.objIntrebareInfo.tip !== 'grupaj' &&


                                                <li style={{ color: this.state.strTip === 'radio' ? '#9fc59c' : '', paddingTop: 0 }} className='chestionar-settings-li' onClick={() => { this.tipChange('radio') }} >O singura varianta de raspuns</li>
                                            }
                                            {this.props.objIntrebareInfo.tip !== 'grupaj' &&

                                                <li style={{ color: this.state.strTip === 'checkbox' ? '#9fc59c' : '' }} className='chestionar-settings-li' onClick={() => { this.tipChange('checkbox') }} >Mai multe variante de raspuns</li>

                                            }



                                            {/* <li style={{ color: this.state.strTip === 'grupaj' ? '#9fc59c' : '' }} className='chestionar-settings-li' onClick={() => { this.tipChange('grupaj') }} >Raspunsuri grupate</li> */}


                                            {/* {this.props.objIntrebareInfo.tip !== 'grupaj' && this.props.chestionarInfo.tip !== new Utils().tipChestionare.chestionareTipCursuri &&


                                                <li style={{ color: this.state.strTip === 'subintrebare' ? '#9fc59c' : '' }} className='chestionar-settings-li' onClick={() => { this.tipChange('subintrebare') }} >Intrebare cu subintrebari</li>

                                            } */}


                                            {this.state.listRaspunsuri.length === 0 && this.props.objIntrebareInfo.tip !== 'grupaj' &&

                                                <li style={{ color: this.state.strTip === 'text' ? '#9fc59c' : '' }} className='chestionar-settings-li' onClick={() => { this.tipChange('text') }} >Text Liber</li>

                                            }





                                        </ul>


                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                                <Divider className='pm-divider' />

                            </div>
                        }

                        {this.props.objIntrebareInfo.id !== null &&
                            this.props.objIntrebareInfo.tip.indexOf('img') !== -1 &&
                            <div>
                                <h3 onClick={() => { this.handleChangePanel('panel1') }} className='cardTitle' style={{ margin: 20, display: 'flex', justifyContent: 'space-between', cursor: 'pointer' }}><span style={{ fontWeight: 700, textTransform: 'uppercase', fontSize: 16 }}>{this.tipuriIntrebariLabel()}</span>
                                    <span>

                                        <CogSolid className='textSecondary iconSvg' style={{ marginRight: 0, width: 18, height: 18 }} />
                                    </span>

                                    {/* <i  className='material-icons iconFontSize textSecondary'>settings</i> */}
                                </h3>

                                <ExpansionPanel className='chestionare-expantion' style={{ margin: 'auto', maxWidth: 350 }} expanded={this.state.panel1} onChange={() => { this.handleChangePanel('panel1') }}>


                                    {/* {this.state.isShowPreview !== true && */}

                                    <ExpansionPanelDetails style={{ display: 'block' }}>

                                        <ul style={{ textAlign: 'left', listStyleType: 'none', marginTop: 0, paddingTop: 0, paddingLeft: 0, borderLeft: '1px solid #f0f0f0' }}>
                                            {this.props.objIntrebareInfo.tip !== 'grupaj' &&


                                                <li style={{ color: this.state.strTip === 'img_single' ? '#9fc59c' : '', paddingTop: 0 }} className='chestionar-settings-li' onClick={() => { this.tipChange('img_single') }} >O singura varianta de raspuns</li>
                                            }
                                            {this.props.objIntrebareInfo.tip !== 'grupaj' &&

                                                <li style={{ color: this.state.strTip === 'img_multiple' ? '#9fc59c' : '' }} className='chestionar-settings-li' onClick={() => { this.tipChange('img_multiple') }} >Mai multe variante de raspuns</li>

                                            }






                                        </ul>


                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                                <Divider className='pm-divider' />

                            </div>
                        }

                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '90%', margin: 'auto' }}>
                            <span style={{ display: 'block', textAlign: 'left' }}>
                                <span style={{ display: 'block', fontSize: 14 }} className='textSecondary'>Raspunsuri</span>
                                <span style={{ fontWeight: 500, fontSize: 14 }} className='textPrimary'>TEXT</span>

                            </span>
                            <Switch
                                className={this.state.img ? 'chestionare-switch' : ''}
                                checked={this.state.img}
                                onChange={this.handleChecked}
                                value="is_img"
                                color="primary"
                            />
                            <span style={{ display: 'block', textAlign: 'right' }}>
                                <span style={{ display: 'block', fontSize: 14 }} className='textSecondary'>Raspunsuri</span>
                                <span style={{ fontWeight: 500, fontSize: 14 }} className='textPrimary'>IMAGINI</span>

                            </span>



                        </div>


                        <Divider className='pm-divider' />

                        {this.props.objIntrebareInfo.id !== null &&
                            this.props.objIntrebareInfo.tip !== 'grupaj' &&
                            <div>
                                <h3 onClick={() => { this.handleChangePanel('panel2') }} className='cardTitle' style={{ margin: 20, display: 'flex', justifyContent: 'space-between', cursor: 'pointer' }}><span style={{ fontWeight: 700, textTransform: 'uppercase', fontSize: 14 }}>Alege un raspuns predefinit</span>
                                    <i className='material-icons iconFontSize textSecondary'>{this.state.panel2 ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</i></h3>

                                <ExpansionPanel className='chestionare-expantion' style={{ margin: 'auto', maxWidth: 350 }} expanded={this.state.panel2} onChange={() => { this.handleChangePanel('panel2') }}>


                                    {/* {this.state.isShowPreview !== true && */}

                                    <ExpansionPanelDetails style={{ display: 'block', padding: 0 }}>

                                        <div>
                                            <List>
                                                {this.filterRaspunsuri()}

                                            </List>



                                        </div>


                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                                <Divider className='chestionare-divider' />

                            </div>
                        }


                        <div>
                            {this.state.loading &&
                                <div style={{ marginTop: 40 }}>
                                    <CircularProgress style={{ width: 60, height: 55, color: '#1bda1b' }} />
                                </div>

                            }

                            {this.props.objIntrebareInfo.id !== null &&
                                !this.state.loading &&
                                this.state.strTip !== 'text' &&
                                this.state.strTip !== 'subintrebare' &&
                                this.state.strTip !== 'grupaj' &&


                                <div>
                                    <ListaRaspunsuri
                                        objIntrebareInfo={this.props.objIntrebareInfo}
                                        objEvaluare={this.props.chestionarInfo}
                                        listaRaspunsuri={this.state.listRaspunsuri}
                                        goToRaspuns={this.goToRaspuns}
                                        openRaspuns={this.addRaspuns}
                                        deleteRaspuns={this.deleteRaspuns}
                                        updateRaspuns={this.updateRaspuns}
                                        changeRaspuns={this.changeRaspuns}
                                        insertRaspuns={this.insertRaspuns}
                                        getRaspunsuri={this.getRaspunsuri}
                                    />

                                </div>


                            }



                            {this.props.objIntrebareInfo.id !== null &&
                                !this.state.loading &&
                                this.state.strTip === 'grupaj' &&
                                <div>
                                    <ListGrupaje
                                        intrebareParent={this.props.objIntrebareInfo}
                                        ref={this.grupajeList}
                                        deleteRaspuns={this.deleteRaspuns}
                                        addCell={this.adaugaRaspunsGrupaj}
                                        addRow={this.insertIntrebareRow}
                                    />


                                </div>


                            }
                        </div>











                    </DialogContent>


                    <DialogActions style={{ justifyContent: 'center', borderTop:'2px solid #e6e6e6', paddingTop:10 }}>



                        <Button style={{ width: 'fit-content', marginBottom: 20, }} variant="contained" onClick={this.closeDialog} className='chestionare-salveaza-button'>
                            {/* <i className='material-icons'>add_circle_outline</i>   */}
                                                Salveaza si inchide
                                             </Button>

                    </DialogActions>


                </Dialog>

                {this.props.objIntrebareInfo.id !== null &&
                    <DialogSubIntrebare
                        open={this.state.isOpenSubintrebare}
                        dialogClose={() => { this.setState({ isOpenSubintrebare: false }) }}
                        getRaspunsuri={() => { this.listSubIntrebari.current.getSubIntrebari() }}
                        getChestionar={this.props.getChestionar}
                        objIntrebareInfo={this.state.objIntrebareChild}
                        updateIntrebare={this.updateSubintrebare}
                        objIntrebareParent={this.props.objIntrebareInfo}
                        numeChange={this.changeSubintrebareTitle}
                        motivatieChange={this.changeMotivatie}
                        title={this.props.nume}
                        ref={this.subIntrebare}
                    />

                }

                <RaspunsDialog
                    open={this.state.isOpenRaspuns}
                    dialogClose={() => { this.setState({ isOpenRaspuns: false, strRaspunsNume: '', strPuncte: '' }) }}
                    nume={this.state.strRaspunsNume}
                    numeChange={(ev) => { this.setState({ strRaspunsNume: ev.target.value }) }}
                    puncte={this.state.strPuncte}
                    puncteChange={(ev) => { this.setState({ strPuncte: ev.target.value }) }}
                    insertUpdate={this.insertRaspuns}
                    getRaspunsuri={this.getRaspunsuri}
                    scop='adauga'
                    tipRaspuns={this.props.objIntrebareInfo.tip}
                    raspuns={this.state.objRaspunsInfo} />

                <RaspunsDialog
                    open={this.state.isOpenRaspunsUpdate}
                    dialogClose={() => { this.setState({ isOpenRaspunsUpdate: false, strRaspunsNume: '', strPuncte: '' }) }}
                    nume={this.state.strRaspunsNume}
                    numeChange={(ev) => { this.setState({ strRaspunsNume: ev.target.value }) }}
                    puncte={this.state.strPuncte}
                    puncteChange={(ev) => { this.setState({ strPuncte: ev.target.value }) }}
                    insertUpdate={this.updateRaspuns}
                    getRaspunsuri={this.getRaspunsuri}
                    tipRaspuns={this.props.objIntrebareInfo.tip}
                    raspuns={this.state.objRaspunsInfo}
                    scop='editeaza' />
            </div>
        );
    }
}


AddIntrebare.propType = {
    nume: PropTypes.string,
    tip: PropTypes.string,
    tipChange: PropTypes.func,
    open: PropTypes.bool,
    dialogClose: PropTypes.func,
    numeChange: PropTypes.func,
    tipuriIntrebari: PropTypes.array,
    insert: PropTypes.func

}


// import React from 'react';
// import {Dialog, DialogActions, DialogContent, Button, TextField, Switch, Fab, FormControl, InputLabel, Select, MenuItem, Input} from '@material-ui/core'
// import PropTypes from 'prop-types'


// export default class AddIntrebare extends React.Component {
//     constructor(props) {
//       super(props);
//        this.state = { 

//         }
//     }

//      componentDidMount(){

//     }


//     showButton = () =>{

//         if((this.props.nume.length > 3)&&(this.props.tip.length > 3)){
//             return false
//         }else{
//           return  true
//         }
//     }


//      render() { 
//        return (
//           <div>
//                <Dialog 
//                  className="insertDialog"
//                 disableBackdropClick
//                 disableEscapeKeyDown
//                 fullWidth={true}
//                 maxWidth={'sm'}
//                  open={this.props.open}
//                  onClose={this.props.dialogClose}>
//                  <DialogActions >
//                  <Fab  onClick={this.props.dialogClose} className="chestionare-anuleaza-button">
//                                       <i className='material-icons chestionare-anuleaza-button-icon'>close</i>
//                             </Fab>
//                  </DialogActions>
//                         <DialogContent style={{textAlign:'center', overflow:'hidden'}}>
//                             <TextField label='Intrebare'
//                                     autoFocus
//                                     multiline
//                                      value={this.props.nume } 
//                                     onChange={this.props.numeChange} 
//                                     className='inputFocus' />

//                         </DialogContent>
//                         <DialogContent style={{textAlign:'center'}}>
//                         <FormControl className='inputFocus' style={{ width: '90%', marginTop: 16 }}>
//                                             <InputLabel htmlFor="beneficiari">Tip Intrebare</InputLabel>
//                                             <Select
//                                                 label=""
//                                                 value={this.props.tip|| ''}
//                                                 onChange={this.props.tipChange}
//                                                 input={<Input id="beneficiari" />}>


//                                               {  this.props.tipuriIntrebari.map((s, idx) => {
//                                                     return <MenuItem value={s.id} key={idx}  > {s.nume}</MenuItem>

//                                                 })
//                                             }
//                                             </Select>
//                                         </FormControl>

//                         </DialogContent>


//                         <DialogActions className="chestionare-dialog-bottom-buttons">

//                             <Button disabled={this.showButton()} variant="contained" onClick={this.props.insert} className={this.showButton() === true ?  '' : 'chestionare-main-button'}>
//                                       Adauga
//                             </Button>


//                         </DialogActions>

//                  </Dialog>
//          </div>
//         );
//        }
// }


// AddIntrebare.propType={
//     nume:PropTypes.string,
//     tip:PropTypes.string,
//     tipChange:PropTypes.func,
//     open:PropTypes.bool,
//     dialogClose:PropTypes.func,
//     nume:PropTypes.string,
//     numeChange:PropTypes.func,
//     tipuriIntrebari:PropTypes.array,
//     insert:PropTypes.func

// }